import { useState } from 'react';

import { useGetSearchResultsMutation } from 'store/api/pkd/endpoints/oneRecord';

export const useListDetailedCareCenters = () => {
  const [getSearchResults, { data, isLoading: isProviderListLoading }] = useGetSearchResultsMutation();
  const [careCenters, setCareCenters] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const searchCareCenters = async (searchTerm, personId, participantTaskId) => {
    if (!searchTerm || searchTerm.length < 4 || !personId) return;
    setIsSearching(true);
    try {
      const res = await getSearchResults({ searchTerm, personId, participantTaskId }).unwrap();
      const mapped =
        res?.map((item) => ({
          id      : item.id,
          name    : item.name,
          address : {
            street : item.street,
            city   : item.city,
            zip    : item.zip,
            state  : item.state,
          },
          redirectUrl : item.redirectUri,
        })) || [];
      setCareCenters(mapped);
      setIsSearching(false);
      return mapped;
    } catch (e) {
      setCareCenters([]);
      setIsSearching(false);
      return [];
    }
  };

  const isLoading = isProviderListLoading || isSearching;
  return { careCenters, isLoading, searchCareCenters };
};

export const useRedirectCareCenter = () => {
  const [isRedirecting, setRedirecting] = useState(false);

  const redirectCareCenter = (redirectUrl) => {
    if (redirectUrl) {
      setRedirecting(true);
      requestAnimationFrame(() => {
        window.location.href = redirectUrl;
      });
    }
  };

  return [redirectCareCenter, { isLoading: isRedirecting }];
};
